import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const configuration = _configuration

export const auditTrailTypes = {
    auditTag: "audit_trail",
}

export const targetTypes = {
    auditTrail: "audit_trail",
}

export function useAuditTrailTags({ 
    auditTrailType: _auditTrailType, 
    targetType: _targetType
}) {

    const [auditTrailType, setAuditTrailType] = useState(_auditTrailType);
    const [targetType, setTargetType] = useState(_targetType)
    // const [actionType, setActionType] = useState(_actionType)

    const { makeCall, serverClient, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "audit_trails/tags";
    const endpoint2 = "audit_trails";

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            let { auditTrailType: overrideAuditTrailType } = props

            let url = getListsUrl(`${endpoint}/${auditTrailType}`, props)

            if (overrideAuditTrailType) {
                url = getListsUrl(`${endpoint}/${overrideAuditTrailType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            // setIsLoading(false);
            // throw error;
            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true

    }

    // const create = async ({ data }) => {

    //     setIsLoading(true)

    //     try {

    //         const url = endpoint2;

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "POST",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    // const update = async ({
    //     id,
    //     data,
    //     targetType: overrideTargetType,
    //     actionType: overrideActionType
    // }) => {

    //     setIsLoading(true)

    //     try {

    //         const url = `${endpoint2}/${id}`

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: actionType,
    //             },
    //             payload: data
    //         }

    //         if (overrideTargetType) postData.scope.target = overrideTargetType
    //         if (overrideActionType) postData.scope.action = overrideActionType

    //         const response = await makeCall({
    //             url,
    //             method: "PUT",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }


    // const modify = async ({ id, data }) => {

    //     setIsLoading(true)

    //     try {

    //         const url = `${endpoint2}/${id}`

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "PUT",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint2}/delete_tag`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    // const get = async ({ id, auditTrailType: overrideAuditTrailType = '', dataTypesArray = [] }) => {

    //     setIsLoading(true);

    //     try {

    //         let url = getUrlWithDataTypes(`${endpoint2}/${auditTrailType}/${id}`, dataTypesArray);

    //         if (overrideAuditTrailType) {
    //             url = getUrlWithDataTypes(`${endpoint2}/${overrideAuditTrailType}/${id}`, dataTypesArray);
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "GET",
    //             payload: {}
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    return {
        isLoading,
        filterOperatorTypes,
        list,
        // get,
        // create,
        // update,
        // modify,
        remove
    }
}